import { ExclamationMark } from "@/icons";
import { Field } from "@headlessui/react";
import { twMerge } from "@/helpers/twMerge";
import { FC } from "react";
type ExpectedFieldProps = {
  value?: unknown;
  placeholder?: unknown;
  disabled?: boolean;
  required?: boolean;
  name?: unknown;
};

export type RectangularFormField<T> = {
  invalidText?: string;
  formControlContainerClassName?: string;
  formControl: FC<
    Omit<T, "formControl" | "invalidText" | "formControlContainerClassName">
  >;
} & T;
export const RectangularFormField = function <T extends ExpectedFieldProps>({
  invalidText,
  formControlContainerClassName,
  formControl: FormControl,
  ...props
}: RectangularFormField<T>) {
  return (
    <Field
      className="group relative flex w-full flex-col"
      disabled={props.disabled}
    >
      <div
        className={twMerge(
          "text-body-m text-body-primary rounded-corner-subtle bg-swdc-cool-gray-100 flex border-1",
          "invalid" in props && props.invalid
            ? "border-swdc-red-500"
            : "border-swdc-gray-200 group-focus-within:outline-swdc-blue-400 group-focus:outline-swdc-blue-400 group-active:outline-swdc-blue-400 group-focus-within:outline-2",
          formControlContainerClassName,
        )}
      >
        <FormControl {...props} />
      </div>
      {"invalid" in props && Boolean(props.invalid) && (
        <div className="flex items-center gap-x-2 pt-px">
          <ExclamationMark className="flex-none" aria-hidden />
          <span
            className="text-body-2xs text-swdc-red-500 text-left leading-none font-medium"
            id={`invalid-${props.name}`}
          >
            {invalidText}
          </span>
        </div>
      )}
    </Field>
  );
};
